import {
  COLOR_APP_TEXT,
  COLOR_NAV_ITEM_NUMBER,
  COLOR_TERTIARY,
} from "../../../theme";
import styled from "@emotion/styled";

const NavItemNumber = styled.span<{ isActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${(props) =>
    props.isActive ? COLOR_APP_TEXT : COLOR_NAV_ITEM_NUMBER};
  color: ${(props) => (props.isActive ? COLOR_TERTIARY : COLOR_APP_TEXT)};
`;

export default NavItemNumber;
